<template>
  <transition name="sheet" appear>
    <div class="sheet-overlay" @click.self="$emit('close')">
      <div class="sheet" :class="{ 'sheet-wide': size === 'wide' }" role="dialog" aria-modal="true">
        <div class="sheet-grab" @click="$emit('close')"></div>
        <div class="sheet-head">
          <h3>{{ title }}</h3>
          <button class="sheet-close" @click="$emit('close')" aria-label="Stäng">✕</button>
        </div>
        <div class="sheet-content">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { onMounted, onBeforeUnmount } from 'vue';

export default {
  name: 'BottomSheet',
  props: {
    title: { type: String, default: '' },
    // 'wide' = bredare dialog på desktop och nästan full höjd på mobil (t.ex. import-mappning).
    size: { type: String, default: 'default' },
  },
  emits: ['close'],
  setup(props, { emit }) {
    function onKey(e) { if (e.key === 'Escape') emit('close'); }
    onMounted(() => document.addEventListener('keydown', onKey));
    onBeforeUnmount(() => document.removeEventListener('keydown', onKey));
    return {};
  },
};
</script>

<style scoped>
.sheet-overlay {
  position: fixed; inset: 0; z-index: 1300;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(3px);
  display: flex; align-items: flex-end; justify-content: center;
}

.sheet {
  background: var(--gym-surface);
  border: 1px solid var(--gym-border);
  border-bottom: none;
  border-radius: var(--gym-radius-lg) var(--gym-radius-lg) 0 0;
  width: 100%; max-width: 560px;
  max-height: 88vh; overflow-y: auto;
  padding: 0.5rem 1.1rem calc(1.1rem + env(safe-area-inset-bottom, 0px));
  box-shadow: var(--gym-shadow);
  display: flex; flex-direction: column; gap: var(--gym-sp-3);
}

.sheet-wide { max-height: 94vh; }

.sheet-grab {
  width: 40px; height: 4px; border-radius: 99px;
  background: var(--gym-border-strong);
  margin: 0.35rem auto 0.1rem; cursor: pointer; flex-shrink: 0;
}

.sheet-head { display: flex; align-items: center; justify-content: space-between; }
.sheet-head h3 { margin: 0; font-size: 1.15rem; color: var(--gym-text); font-weight: 700; }
.sheet-close {
  background: var(--gym-surface-2); border: 1px solid var(--gym-border);
  color: var(--gym-text-muted); width: 32px; height: 32px; border-radius: 50%;
  cursor: pointer; font-size: 0.85rem; transition: background var(--gym-dur) var(--gym-ease);
}
.sheet-close:hover { background: var(--gym-surface-3); color: var(--gym-text); }

.sheet-content { display: flex; flex-direction: column; gap: var(--gym-sp-3); }

/* ── transitions ── */
.sheet-enter-active, .sheet-leave-active { transition: opacity var(--gym-dur-lg) var(--gym-ease); }
.sheet-enter-active .sheet, .sheet-leave-active .sheet {
  transition: transform var(--gym-dur-lg) var(--gym-ease-spring);
}
.sheet-enter-from, .sheet-leave-to { opacity: 0; }
.sheet-enter-from .sheet, .sheet-leave-to .sheet { transform: translateY(100%); }

/* Centered dialog on larger screens */
@media (min-width: 600px) {
  .sheet-overlay { align-items: center; }
  .sheet {
    border-radius: var(--gym-radius-lg);
    border-bottom: 1px solid var(--gym-border);
    max-height: 84vh; padding-bottom: 1.25rem;
  }
  .sheet-wide { max-height: 94vh; }

.sheet-grab { display: none; }
  .sheet-enter-from .sheet, .sheet-leave-to .sheet { transform: translateY(16px) scale(0.97); }
}
</style>
